import React from 'react';
import {
	isLanguagesListShown as setIsLanguagesListShown,
	setLanguage
} from '../../../../../../../actions/languageActions';
import {useDispatch, useSelector} from 'react-redux';
import DEFlag from './components/de-flag/index';
import ENFlag from './components/en-flag/index';
import ESFlag from './components/es-flag/index';
import FRFlag from './components/fr-flag/index';
import HEFlag from './components/he-flag/index';
import ITFlag from './components/it-flag/index';
import JAFlag from './components/ja-flag/index';
import KOFlag from './components/ko-flag/index';
import NLFlag from './components/nl-flag/index';
import PTBRFlag from './components/pt-br-flag/index';
import RUFlag from './components/ru-flag/index';
import Button from '../../../../../button';
import './index.css';

function LanguageSelector () {

	const language = useSelector(state => state.languageReducer.language);
	const isLanguagesListShown = useSelector(state => state.languageReducer.isLanguagesListShown);

	const dispatch = useDispatch();

	const handleClick = () => {
		if(!isLanguagesListShown){
			dispatch(setIsLanguagesListShown(true));
		} else {
			dispatch(setIsLanguagesListShown(false));
		}
	};

	const onSelectLanguage = (language) => {
		dispatch(setLanguage(language));
		dispatch(setIsLanguagesListShown(false));
	};

	const showFlag = () => {
		switch (language) {
			case 'de' :
				return <DEFlag onClick={() => dispatch(setIsLanguagesListShown(false))}/>;
			case 'es' :
				return <ESFlag onClick={() => dispatch(setIsLanguagesListShown(false))}/>;
			case 'fr' :
				return <FRFlag onClick={() => dispatch(setIsLanguagesListShown(false))}/>;
			case 'he' :
				return <HEFlag onClick={() => dispatch(setIsLanguagesListShown(false))}/>;
			case 'it' :
				return <ITFlag onClick={() => dispatch(setIsLanguagesListShown(false))}/>;
			case 'ja' :
				return <JAFlag onClick={() => dispatch(setIsLanguagesListShown(false))}/>;
			case 'ko' :
				return <KOFlag onClick={() => dispatch(setIsLanguagesListShown(false))}/>;
			case 'nl' :
				return <NLFlag onClick={() => dispatch(setIsLanguagesListShown(false))}/>;
			case 'ptBr' :
				return <PTBRFlag onClick={() => dispatch(setIsLanguagesListShown(false))}/>;
			case 'ru' :
				return <RUFlag onClick={() => dispatch(setIsLanguagesListShown(false))}/>;
			default:
				return <ENFlag onClick={() => dispatch(setIsLanguagesListShown(false))}/>;
		}
	};

	return (
		<div className="language-selector" onClick={handleClick}>
			{
				isLanguagesListShown && <ul className="language-list" onMouseLeave={() => dispatch(setIsLanguagesListShown(false))}>
					<li className="col-2"><Button className="btn-link text-decoration-none" onClick={() => onSelectLanguage('de')}><DEFlag /></Button></li>
					<li className="col-2"><Button className="btn-link text-decoration-none" onClick={() => onSelectLanguage('en')}><ENFlag /></Button></li>
					<li className="col-2"><Button className="btn-link text-decoration-none" onClick={() => onSelectLanguage('es')}><ESFlag /></Button></li>
					<li className="col-2"><Button className="btn-link text-decoration-none" onClick={() => onSelectLanguage('fr')}><FRFlag /></Button></li>
					<li className="col-2"><Button className="btn-link text-decoration-none" onClick={() => onSelectLanguage('he')}><HEFlag /></Button></li>
					<li className="col-2"><Button className="btn-link text-decoration-none" onClick={() => onSelectLanguage('it')}><ITFlag /></Button></li>
					<li className="col-2"><Button className="btn-link text-decoration-none" onClick={() => onSelectLanguage('ja')}><JAFlag /></Button></li>
					<li className="col-2"><Button className="btn-link text-decoration-none" onClick={() => onSelectLanguage('ko')}><KOFlag /></Button></li>
					<li className="col-2"><Button className="btn-link text-decoration-none" onClick={() => onSelectLanguage('nl')}><NLFlag /></Button></li>
					<li className="col-2"><Button className="btn-link text-decoration-none" onClick={() => onSelectLanguage('ptBr')}><PTBRFlag /></Button></li>
					<li className="col-2"><Button className="btn-link text-decoration-none" onClick={() => onSelectLanguage('ru')}><RUFlag /></Button></li>
				</ul>
			}
			<button type="button">
				{showFlag()}
			</button>
		</div>
	)
}

export default LanguageSelector;
